import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MbTooltip from 'components/atoms/MbTooltip';
import Icon from 'components/atoms/Icon';
const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: '#fff',
    border: '1px solid #e8e9ec',
    '&:hover': {
      backgroundColor: theme.palette.primary.deep,
      color: theme.palette.common.white,
    },
  },
  filterButton: {
    backgroundColor: '#fff',
    border: '1px solid #e5e8eb',
    textTransform: 'none',
    color: '#000',
    '&:hover': {
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
    },
    cursor: 'pointer',
  },
  filtered: {
    backgroundColor: theme.palette.primary.deep,
    color: '#fff',
  },
  iconBtn: {
    minWidth: '28px',
    height: '28px',
    padding: '2px',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
    },
  },
  modalBtn: {
    height: '34px',
    '& > span': {
      marginLeft: 11,
      marginRight: 11,
      fontSize: 14,
    },
  },
  upLoad: {
    padding: '6px 8px',
    backgroundColor: '#fff',
    border: '1px solid #e8e9ec',
    boxShadow: 'none',
    color: 'rgba(0, 0, 0, 0.87)',
    '&:hover': {
      color: '#fff',
      backgroundColor: theme.palette.primary.main,
      boxShadow: 'none',
    },
    '&.hasFile': {
      backgroundColor: theme.palette.primary.deep,
      color: theme.palette.common.white,
    },
  },
  upLoadInput: { display: 'none' },
  deleteStyle: { '&:hover': { backgroundColor: theme.palette.common.red } },
}));

const NewButton = (props) => {
  const classes = useStyles();
  const {
    children,
    title,
    placement = 'right-start',
    className,
    name,
    icon = undefined,
    iconBtn = false,
    type,
    color,
    onClick = (f) => f,
    changeEvent = (f) => f,
    disableRipple = false,
    upLoad = false,
    filtered,
    deleteFile = false,
    boxStyle = {},
    ...rest
  } = props;

  const [upLoadFile, setUpLoadFile] = useState(false);

  useEffect(() => {
    if (deleteFile) {
      setUpLoadFile(false);
    }
  }, [deleteFile]);

  const handleUpLoad = (e) => {
    if (typeof e.target.files[0] !== 'object') {
      return false;
    }
    setUpLoadFile(e.target.files[0].name);
    changeEvent(e);
  };

  const fileInput = useRef();
  return upLoad ? (
    <div>
      <input
        className={classes.upLoadInput}
        id="buttonFile"
        multiple
        type="file"
        onChange={handleUpLoad}
        ref={fileInput}
      />
      <label htmlFor="buttonFile">
        <Button
          color="primary"
          component="span"
          classes={{ root: classes.upLoad }}
          className={clsx(!!upLoadFile && 'hasFile')}
          {...rest}
        >
          {upLoadFile ? upLoadFile : children}
        </Button>
      </label>
    </div>
  ) : (
    <div style={boxStyle}>
      {typeof title === 'string' ? (
        <MbTooltip title={title} placement={placement} disableFocusListener>
          <Button
            className={clsx(
              classes.button,
              type === 'filterButton' && classes.filterButton,
              type === 'modalBtn' && classes.modalBtn,
              className
            )}
            classes={{ root: iconBtn && classes.iconBtn }}
            disableRipple={type === 'modalBtn' || disableRipple}
            name={name}
            onClick={onClick}
            {...rest}
          >
            {iconBtn && (
              <Icon
                icon={icon}
                color={typeof color === 'undefined' ? '#8d9ba2' : color}
              />
            )}
            {children}
          </Button>
        </MbTooltip>
      ) : (
        <Button
          className={clsx(
            classes.button,
            type === 'filterButton' && classes.filterButton,
            type === 'modalBtn' && classes.modalBtn,
            type === 'delete' && classes.deleteStyle,
            filtered && classes.filtered,
            className
          )}
          classes={{ root: iconBtn && classes.iconBtn }}
          disableRipple={type === 'modalBtn'}
          name={name}
          onClick={onClick}
          {...rest}
        >
          {iconBtn && (
            <Icon
              icon={icon}
              color={typeof color === 'undefined' ? '#8d9ba2' : color}
            />
          )}
          {children}
        </Button>
      )}
    </div>
  );
};

// NewButton.propTypes = {
//   categorySelecteList: PropTypes.array,
//   useABlockList: PropTypes.array,
// };

export default NewButton;
